import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clickable'
})
export class ClickablePipe implements PipeTransform {

  transform(value: string) {
    const re = /[\s, \.;]+/;
    const words: { word: string; clickable: boolean }[] = [];
    let lastWord = '';
    for (const letter of value) {
      if (re.test(letter)) {
        if (lastWord.length > 0) {
          words.push({ word: lastWord, clickable: true });
          lastWord = '';
        }
        words.push({ word: letter, clickable: false });
      } else {
        lastWord += letter;
      }
    }
    if (lastWord.length > 0) {
      words.push({ word: lastWord, clickable: true });
    }
    console.log(words);
    return words;
  }

}
